"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = exports.mapData = exports.getGroupName = exports.getName = exports.createRowDataFromProps = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var avatars_1 = require("components/Avatar/avatars");
var permissions_1 = require("./permissions");
var createRowDataFromProps = function (props) { return ({
    isCollapsed: props.isCollapsed,
    isDeleteColumnHidden: props.isDeleteColumnHidden,
    isEditColumnHidden: props.isEditColumnHidden,
    isValidityColumnHidden: props.isValidityColumnHidden,
    items: props.items,
    selectedGroups: props.selectedGroups,
    selectedUsers: props.selectedUsers,
    style: {},
    collapseUserRow: props.collapseUserRow,
    deleteGroup: props.deleteGroup,
    deleteUsers: props.deleteUsers,
    editGroup: props.editGroup,
    openUserSettingsModal: props.openUserSettingsModal,
    setGroupsSelected: props.setGroupsSelected,
    setWarningModal: props.setWarningModal,
    setUsersSelected: props.setUsersSelected
}); };
exports.createRowDataFromProps = createRowDataFromProps;
var getName = function (user) { return "".concat(user.firstName, " ").concat(user.lastName); };
exports.getName = getName;
var getGroupName = function (group) {
    switch (group.type) {
        case 'LightAdminCategoryUserGroup':
            return (0, translation_1.getLocalization)('userfront/project/teamMembers/lightAdmins');
        case 'WorksiteDiaryUserGroup': {
            return ((0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryUserGroup') +
                ' - ' +
                group.name);
        }
        case 'TRMVRUserGroup': {
            var type = group.meterType === 'MVRMETER' ? 'MVRMETER' : 'TRMETER';
            return ((0, translation_1.getLocalization)("userfront/project/teamMembers/trmvrMeterUserGroup/".concat(type)) +
                ' - ' +
                group.name);
        }
        default:
            return group.name;
    }
};
exports.getGroupName = getGroupName;
var mapData = function (list, collapsed, perm, disabled) {
    return list.reduce(function (acc, item) {
        acc.push(__assign({ type: 'CATEGORY', group: item.category, indent: 0 }, (0, permissions_1.getPerm)(item.category.type, 'GROUP', perm, disabled)));
        if (collapsed.includes(item.category.id)) {
            return acc;
        }
        item.category.members.forEach(function (user) {
            acc.push(__assign({ type: 'USER', user: user, indent: 1, group: item.category }, (0, permissions_1.getPerm)(item.category.type, 'USER', perm, disabled)));
        });
        return item.groups.reduce(function (ac, group) {
            ac.push(__assign({ type: 'GROUP', group: group, indent: 1 }, (0, permissions_1.getPerm)(group.type, 'GROUP', perm, disabled)));
            if (collapsed.includes(group.id)) {
                return ac;
            }
            return (group.members || []).reduce(function (a, user) {
                a.push(__assign({ type: 'USER', user: user, indent: 2, group: group }, (0, permissions_1.getPerm)(group.type, 'USER', perm, disabled)));
                return a;
            }, ac);
        }, acc);
    }, []);
};
exports.mapData = mapData;
var getIcon = function (row) {
    if (row.type === 'USER') {
        return React.createElement("img", { className: 'icon', src: (0, avatars_1.getAvatarUrl)(row.user.avatar) });
    }
    if (row.group.id === -1 && row.group.type === 'NormalUserGroup') {
        return React.createElement(sok_ui_1.Icon, { className: 'fa-trophy' });
    }
    switch (row.group.type) {
        case 'CustomerCategoryUserGroup':
            return React.createElement(sok_ui_1.Icon, { className: 'fa-archive' });
        case 'SuperAdminUserGroup':
        case 'SalesmanUserGroup':
        case 'CustomerAdminUserGroup':
        case 'CustomerVisibilityUserGroup':
        case 'ProjectAdminUserGroup':
        case 'CategoryUserGroup':
        case 'SokoBidCategoryUserGroup':
        case 'TRMVRUserGroup':
        case 'WorksiteDiaryUserGroup':
            return React.createElement(sok_ui_1.Icon, { className: 'fa-trophy' });
        default:
            return (React.createElement(sok_ui_1.Icon, { className: row.group.type === 'SokoBidUserGroup' ? 'fa-briefcase' : 'fa-users' }));
    }
};
exports.getIcon = getIcon;
